import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useSite } from '../../site/SiteContext';
import SiteLink from './SiteLink';

/**
 * Cookie consent banner (Marketing & SEO → Cookie consent banner). The
 * choice goes to window.darafConsent, written into the page by Laravel,
 * which then loads (or keeps off) the marketing tags.
 */
export default function ConsentBanner() {
    const { site } = useSite();
    const consent = site.consent;
    const [choice, setChoice] = useState(() => (typeof window.darafConsentChoice === 'function' ? window.darafConsentChoice() : 'accepted'));

    if (!consent?.enabled || choice) return null;

    const answer = (value) => {
        window.darafConsent?.(value);
        setChoice(value);
    };

    return (
        <Box
            role="dialog"
            aria-live="polite"
            sx={{
                position: 'fixed',
                insetInline: { xs: 12, sm: 24 },
                bottom: { xs: 12, sm: 24 },
                zIndex: 1400,
                maxWidth: 560,
                mx: 'auto',
                p: { xs: 2.5, sm: 3 },
                borderRadius: '1.25rem',
                backgroundColor: '#1c1a17',
                color: '#fff',
                boxShadow: '0 24px 60px -20px rgba(0,0,0,0.6)',
            }}
        >
            <Typography sx={{ fontWeight: 700, fontSize: '1.05rem', mb: 1 }}>{consent.title}</Typography>
            <Typography sx={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.75)', lineHeight: 1.7 }}>
                {consent.text}{' '}
                {consent.privacy?.url && (
                    <SiteLink to={consent.privacy.url} style={{ color: '#d4b983' }}>
                        {consent.privacy.text}
                    </SiteLink>
                )}
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                <Button onClick={() => answer('accepted')} sx={{ backgroundColor: '#b8975a', color: '#1c1a17', fontWeight: 700, textTransform: 'none', px: 3, '&:hover': { backgroundColor: '#d4b983' } }}>
                    {consent.accept}
                </Button>
                <Button onClick={() => answer('rejected')} sx={{ color: '#fff', border: '1px solid rgba(255,255,255,0.3)', textTransform: 'none', px: 3 }}>
                    {consent.reject}
                </Button>
            </Box>
        </Box>
    );
}
